import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToTimezone'
})
export class UtcToTimezonePipe implements PipeTransform {

  transform(utcDateString: string, timezone: string): string {
    if (!utcDateString || !timezone) {
      return utcDateString;
    }

    // Parse the UTC date string
    // Handles formats: "2026/02/03 19:45:54" or "2026-02-03T19:46:32"
    let date: Date;
    if (utcDateString.includes('T')) {
      // ISO format - append Z to ensure UTC interpretation
      date = new Date(utcDateString + 'Z');
    } else {
      // Space-separated format
      date = new Date(utcDateString + ' UTC');
    }

    // Convert to the specified timezone
    return date.toLocaleString('en-GB', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).replace(',', '');
  }

}
